module.exports = __webpack_public_path__ + "img/book-cover.c65a41ef.png";